exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.google-ads[data-v-247cd793] {\n  width: 90%;\n}\n.about[data-v-247cd793] {\n  text-align: center;\n}\n.about a[data-v-247cd793] {\n    color: #0096d9;\n    text-decoration: none;\n}\n.about .fa-heart[data-v-247cd793] {\n    color: red;\n}\n.about .badge[data-v-247cd793] {\n    width: auto;\n    height: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-247cd793","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/About.vue
// module id = 65
// module chunks = 0